import React, { useEffect } from 'react';
import { useRouter } from 'next/router';
import cc from 'classcat';
import { observer } from 'mobx-react-lite';
import { useFormikContext } from 'formik';
import styles from './SwitchShips.module.sass';
import { CruiseType } from '../../SearchCruises/SearchCruises';
import { useShipsSearchStore } from '../../../providers/RootStoreProvider';
import { YaAndGaShipPage } from '../../../lib/YaAndGaHelper';

export const SwitchShips = observer(({ className, ...props }) => {
  const { setFieldValue } = useFormikContext();

  const store = useShipsSearchStore();

  const router = useRouter();

  const handleChange = value => () => {
    store.clearFilters();
    setFieldValue(props.name, value);
    store.getList(value);
  };

  const updateResult = value => {
    setFieldValue(props.name, value);
    store.getList(value);
  };

  useEffect(() => {
    const { type } = router.query;
    type === 'sea'
      ? updateResult(CruiseType.Sea)
      : updateResult(CruiseType.Rivers);
  }, []);

  return (
    <div
      className={cc([styles.switchShips, { [className]: !!className }])}
      {...props}
    >
      <div className={styles.wrap}>
        <button
          className={cc([
            { [styles.active]: CruiseType.Rivers === props.value },
            styles.button,
          ])}
          onClick={() => {
            handleChange(CruiseType.Rivers)();
            YaAndGaShipPage('click_rivers');
          }}
          type="button"
        >
          Речные
        </button>
        <button
          className={cc([
            { [styles.active]: CruiseType.Sea === props.value },
            styles.button,
          ])}
          onClick={() => {
            handleChange(CruiseType.Sea)();
            YaAndGaShipPage('click_seas');
          }}
          type="button"
        >
          Морские
        </button>
      </div>
    </div>
  );
});
